import React from 'react';
import Post from './Post';

const CommentPage = () => {
  return (
    <div className="pb-5 bg-lightblue">
      <div className="bg-lightblue py-3 px-5 border grid grid-cols-2">
        <p>Comments and Mentions</p>
        <p>
          Filters <i className="fa-solid fa-filter"></i>
        </p>
      </div>
      <p className="text-lg font-semibold px-5 py-3">Today</p>
      <section className="px-5 py-3 space-y-10 max-h-[530px] overflow-y-auto">
        <Post />
        <Post />
        <Post />
        <Post />
      </section>
    </div>
  );
};

export default CommentPage;
